<template>
  <base-page>
    <img style="width: 100%; max-width: 350px;" src="../assets/weekly-results.png" alt="">
    <div class="rps_12e0">
      <div class="x_container">
        <div class="rps_12e0">

          <label for="country">
            <select name="country" id="" placeholder="Country" v-model="country" @input="updateSelectedCountry">
              <option value="" disabled selected>Country</option>
              <option value="All">All</option>
              <option :value="country.value" v-for="(country, i) in allCountries"
                      v-bind:key="i">{{ country.value }}</option>
            </select>
          </label>

          <label for="department">
            <select name="department" id="" v-model="department" @input="updateSelectedDepartment">
              <option value="" disabled selected>Department</option>
              <option value="All">All</option>
              <option :value="department.value" v-for="(department,i) in allDeparments"
                      v-bind:key="i">{{ department.value }}</option>
            </select>
          </label>

          <label for="week">
            <select name="week" id="" v-model="currentWeek" @input="getFormData">
              <option value="" disabled>Week</option>
              <option :value="week" v-for="(week, i) in weeks"
                      :key="i+1" :selected="week === currentWeek">{{ week }}
              </option>
            </select>
          </label>
        </div>
      </div>
      <div class="x_container" style="overflow-x: auto;" v-if="monitoringData">

        <table>
          <tr class="header">
            <td @click="sortTable('country')">Country</td>
            <td @click="sortTable('department')">Department</td>
            <td @click="sortTable('userId')">Email</td>
            <td @click="sortTable('workload')"><img src="../assets/wl-green.svg" height="40" width="40" alt=""></td>
            <td @click="sortTable('workload')"><img src="../assets/wl-orange.svg" height="40" width="40" alt=""></td>
            <td @click="sortTable('workload')"><img src="../assets/wl-red.svg" height="40" width="40" alt=""></td>
            <td @click="sortTable('workload')"><img src="../assets/wl-black.svg" height="40" width="40" alt=""></td>
            <td @click="sortTable('workload')"><img src="../assets/wl-white.svg" height="40" width="40" alt=""></td>
          </tr>
          <tr class="data-rows" v-for="(employee, i) in monitoringData" v-bind:key="i" :class="{'not-answered': employee.not_answered}">
            <td>{{ employee.country }}</td>
            <td>{{ employee.department }}</td>
            <td>{{ employee.userId }}</td>
            <td class="t-cell" :class="{ 'green' : employee.workload === '1' }"></td>
            <td class="t-cell" :class="{ 'orange' : employee.workload === '2' }"></td>
            <td class="t-cell" :class="{ 'red' : employee.workload === '3' }"></td>
            <td class="t-cell" :class="{ 'black' : employee.workload === '4' }"></td>
            <td class="t-cell" :class="{ 'white' : employee.workload === '0' }"></td>
          </tr>
        </table>
      </div>

      <div class="x_container" style="overflow-x: auto;" v-if="monitoringData">
        <table>
          <tr class="header">
            <td></td>
            <td class="rotate">Feelings</td>
            <td class="rotate">Goals</td>
            <td class="rotate">Learning</td>
          </tr>
          <tr class="data-rows" v-for="(employee, i) in monitoringData" v-bind:key="i" :class="{'not-answered': employee.not_answered}">
            <td>{{ employee.userId }}</td>
            <td class="t-cell" :class="'fgl-'+employee.happiness"></td>
            <td class="t-cell" :class="'fgl-'+employee.goals"></td>
            <td class="t-cell" :class="'fgl-'+employee.knowledge"></td>
          </tr>
        </table>
      </div>
    </div>
  </base-page>
</template>

<script>

export default {
  name: 'monitoring',
  data () {
    return {
      country: '',
      department: '',
      currentWeek: this.getCurrentWeek() - 1,
      weeks: this.getCurrentWeek(),
      currentSort: 'userId',
      currentSortDir: 'asc'
    }
  },
  mounted () {
    this.$store.dispatch('getAllUsers')
    this.getFormData()
  },
  computed: {
    isManager () {
      return this.$store.getters.isManager
    },
    formData () {
      return this.$store.getters.formResponses
    },
    allCountries () {
      return this.$store.getters.getCountries
    },
    allDeparments () {
      return this.$store.getters.getDepartments
    },
    monitoringData () {
      const data = this.$store.getters.monitoringData

      return data.sort((a, b) => {
        let modifier = 1
        const compareA = a[this.currentSort] || 'patata'
        const compareB = b[this.currentSort] || 'patata'
        if (this.currentSortDir === 'desc') {
          modifier = -1
        }
        if (compareA < compareB) {
          return -1 * modifier
        }
        if (compareA > compareB) {
          return 1 * modifier
        }
        return 0
      })
    }
  },
  methods: {
    sortTable (value) {
      // if s == current sort, reverse
      if (value === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = value
    },
    getCurrentWeek () {
      // eslint-disable-next-line
      Date.prototype.getWeekNumber = function () {
        const d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()))
        const dayNum = d.getUTCDay() || 7
        d.setUTCDate(d.getUTCDate() + 4 - dayNum)
        const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
        return Math.ceil((((d - yearStart) / 86400000) + 1) / 7) + 1
      }
      return new Date().getWeekNumber()
    },
    updateSelectedCountry (event) {
      const country = event.target.value === 'All' ? null : event.target.value
      this.$store.commit('UPDATE_SELECTED_COUNTRY', country)
    },
    updateSelectedDepartment (event) {
      const department = event.target.value === 'All' ? null : event.target.value
      this.$store.commit('UPDATE_SELECTED_DEPARTMENT', department)
    },
    getFormData (event) {
      console.log('CURRENT WEEK <------')
      console.log(this.currentWeek)
      if (!event) {
        this.$store.dispatch('formResponsesData', { week: this.currentWeek })
      } else {
        this.$store.dispatch('formResponsesData', { week: event.target.value })
      }
    }
  }
}
</script>

<style>
* {
  font-family: 'Helvetica', 'Neue';
}
body {
  color: #FFF;
  background: #17445F;
  margin: 0;
}
.x_cabecera {
  color: #FFF;
  font-size: 13px;
  background-color: #4D6F84;
  text-align: center;
  padding: .5em;
  margin-bottom: 5em;
}
h1 {
  margin: 0px;
}
.rps_12e0 .x_container {
  margin: 20px 20px 0px 20px;
  border: 0px;
  text-align: center;
  font-size: 12px;
}
tr.header > td {
  cursor: pointer;
}
.link-no-style {
  text-decoration: none;
  color: #FFF;
}
.rps_12e0 {
  padding-bottom: 4em;
}
.rps_12e0 .x_fecha{
  background: #f42;
  padding: 10px 0 10px 15px;
  color: #fff;
  font-size: 12px;
  text-align: left;
}

.rps_12e0 .x_fecha_form {
  margin-top: 0px;
  background-color: #769CB3;
  padding: 10px 0 10px 15px;
  color: #0F2D3E;
  font-weight: bold;
  font-size: 12px;
  text-align: left;
}
@media (max-width: 600px) {
  .rps_12e0 .x_container {
    display: inherit !important;
  }
}
tr.data-rows, tr.data-rows > td {
  border-collapse: collapse;
  border: 1px solid #FFF;
}

table {
  width: 50%;
  border-collapse: collapse;
  text-align: center;
  margin: 0px auto;
}

td {
  padding: 1em;
  color: #FFF;
}
tr.data-rows:hover {
  background-color: #769CB3;
}
tr.data-rows:hover td {
    background-color: transparent; /* or #000 */
}
tr.header td {
  color: #FFF;
  font-size: 14px;
  font-weight: bold;
}
label {
  color: #FFF;
}
#app {
  margin-top: 0px;
  margin-bottom: 1em;
}

select {
  width: 144.5px;
  height: 31px;
  margin: .5em;
  color: #6F6F6F;
  font-size: 12px;
  /* styling */
  background-color: white;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 0.5em 3.5em 0.5em 1em;

  /* reset */
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}

select {
  background-image:
    linear-gradient(45deg, transparent 50%, #0075CB 50%),
    linear-gradient(135deg, #0075CB 50%, transparent 50%),
    linear-gradient(to right, white, white);
  background-position:
    calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px),
    100% 0;
  background-size:
    5px 5px,
    5px 5px,
    2.5em 2.5em;
  background-repeat: no-repeat;
}
.green {
  background-color: #CED42C;
}
.red {
  background-color: #D9391F;
}
.orange {
  background-color: #F39D26;
}
.black {
  background-color: #333;
}
.white {
  background-color: #D6EBEC;
}
.fgl-1 {
  background-color: #8FE252;
}
.fgl-2 {
  background-color: #3EDAFF;
}
.fgl-4 {
  background-color: #D9391F;
}
.fgl-3 {
  background-color: #FFD14D;
}
/* .rotate {
  transform: rotate(-65deg);
  margin-bottom: 13em;
  height: 60px;
  text-transform: uppercase;
} */
select[disabled] {
  background-color: #d6d6d6;
  cursor: not-allowed;
}
.not-answered {
  background-color: rgba(255, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Monitoring.vue